<template>
  <page-template >
    <template slot="page-content" class="soma-header">
      <section class="db relative center mw8-4 margin-fix-soma">
        <h1 class="is-navy is-blenny soma-header lh-heading f-page-title center">{{ page.seo_title }}</h1>
            <div class="" v-if="page.admat_section.is_link_out">
              <a
                :href="page.admat_section.link"
                v-if="page.admat_section.header_text && page.admat_section.link"
                class="db relative mb4 center f4 f3-ns is-ls-1 is-lorano-bold is-navy link tc"
                v-html="marked(page.admat_section.header_text)"
                target="_blank"
              ></a>
              <a
                href="https://outsidelands.shop.musictoday.com/store/"
                v-else
                class="db relative mb4 center f4 f3-ns is-ls-1 is-lorano-bold is-navy link tc"
                target="_blank"
                >{{ page.admat_section.header_text }}</a
              >
            </div>
            <div class="" v-else>
              <router-link
                :to="page.admat_section.link"
                v-if="page.admat_section.header_text && page.admat_section.link"
                class="db relative mb4 center f4 f3-ns is-ls-1 is-lorano-bold is-navy link tc"
                v-html="marked(page.admat_section.header_text)"
              ></router-link>
              <router-link
                to="/tickets"
                v-else
                class="db relative mb4 center f4 f3-ns is-ls-1 is-lorano-bold is-navy link tc"
                >{{ page.admat_section.header_text }}</router-link
              >
            </div>
            <!-- <a class="db relative ph4 ph5-ns pv4 pv5-ns pointer bg-navy bg-bows-blue">-->
            <a
              class="db relative pt0 pt4-ns pb4 pointer admat-soma"
              href="/lineup/#/lineup_groupings/soma-tent"
              title="Outside Lands 2021 Lineup"
            >
              <img
                v-show="isWindowWidthMobile"
                class="db dn-ns relative "
                v-lazy="page.admat_section.mobile_image"
              />
              <img
                v-show="!isWindowWidthMobile"
                class="dn db-ns relative  admat-regular"
                v-lazy="page.admat_section.desktop_image"
              />
              
            </a>
            <p class="f22px padding-ugh is-tablet-regular link-bold lh-copy" v-html="marked(page.intro_text)"></p>
            <!-- <a :href="page.lineup_button.link">{{page.lineup_button.copy}}</a> -->
            <router-link
              class="db relative center mw6 ph4 btn-primary has-red-bg"
              :to="page.lineup_button.link"
            >
              <span class="text">
                {{ page.lineup_button.copy }}
              </span>
            </router-link>
          </section>
          <div class="pic-left3">
                <div
                  v-scrollanimation
                  class="dn db-ns bigger-img icon-image relative nt4 nl5-ns"
                >
                  <img
                    v-scrollanimation
                    class="mw21rem icon icon-margin"
                    src="/uploads/OL20-OL21_Icons/DJ_Icon/DJ_Icon_SVG/DJ_Icon_Infrared.svg"
                  />
                  <!-- <img
                    v-scrollanimation
                    class="mw21rem icon-2 icon-margin"
                    src="/uploads/OL20-OL21_Icons/Fork_Knife Icon/Fork_Knife_Icon_SVG/Fork_Knife_Icon_Blue.svg"
                  /> -->
                  <img
                    v-scrollanimation
                    class="mw21rem icon icon-margin"
                    src="/uploads/OL20-OL21_Icons/DJ_Icon/DJ_Icon_SVG/DJ_Icon_Blue.svg"
                  />
                  <img
                    v-scrollanimation
                    class="mw21rem icon-2 icon-margin"
                    src="/uploads/OL20-OL21_Icons/DJ_Icon/DJ_Icon_SVG/DJ_Icon_Infrared.svg"
                  />
                  <!-- <img
                    v-scrollanimation
                    class="mw21rem pic-margin"
                    src="/uploads/NUM-BEER/OUTSIDE-BEER-3.jpg"
                  /> -->
                </div>
              </div>
              <div class="pic-right3">
                <div
                  v-scrollanimation
                  class="dn db-ns bigger-img icon-image relative nt4 nl5-ns"
                >
                  <img
                    v-scrollanimation
                    class="mw21rem icon icon-margin"
                    src="/uploads/OL20-OL21_Icons/DJ_Icon/DJ_Icon_SVG/DJ_Icon_Infrared.svg"
                  />
                  <img
                    v-scrollanimation
                    class="mw21rem icon icon-margin"
                    src="/uploads/OL20-OL21_Icons/DJ_Icon/DJ_Icon_SVG/DJ_Icon_Blue.svg"
                  />
                  <!-- <img
                    v-scrollanimation
                    class="mw21rem pic-margin"
                    src="/uploads/NUM-BEER/OUTSIDE-BEER-5.jpg"
                  /> -->
                  
                </div>
              </div>
            
    </template>
  </page-template>
</template>

<script>
import PageTemplate from './page-template.vue';
import AccoladesSwiper from "./accolades-swiper.vue";
import AccoladesStatic from "./accolades-static.vue";
import { Slider, SliderItem } from "vue-easy-slider";
import BeerData from '../../beer-2021.json'
export default {
  components: {
    AccoladesSwiper,
    AccoladesStatic,
    PageTemplate,
    Slider,
    SliderItem
  },
  props: ['id','pageMarkdownFileName'],
  metaInfo () {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        return titleChunk ? `${titleChunk} | ` + this.$site_seo_title_suffix : this.$site_seo_title_suffix;
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.page.seo_description }
      ]
    }
  },
  data () {
    return {
      beerData: BeerData,
      newArray: [],
      bgOpaciy: 0,
      bgScrollStart: 10,
      scrollPos: 0,
      swiperOptions: {
        speed: 700,
        autoplayDisableOnInteraction: false,
        loop: true,
        initialSlide: 0,
        paginationClickable: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom"></span>`;
          }
        },
        keyboardControl: true,
        navigation: {
          nextEl: ".swiper-button-next-home",
          prevEl: ".swiper-button-prev-home"
        },
        initialSlide: 0,
        spaceBetween: 0,
        centeredSlides: true,
        slidesPerView: 2.2,
        afterLoad: false,
        breakpoints: {
          540: {
            slidesPerView: 1.3
          },
          840: {
            slidesPerView: 1.8,
            loopAdditionalSlides: 1
          }
        }
      },
      parallax:null,
      window: {
        width: 0,
        height: 0
      },
      list: [
        { width: "100%", height: "100%" },
        { width: "100%", height: "100%" },
        { width: "100%", height: "100%" },
        { width: "100%", height: "100%" },
        { width: "100%", height: "100%" },
        { width: "100%", height: "100%" }
      ],
      sliderValue: 2,
      newArray: [],
      currentNumber: 0,
      timer: null,
      isWindowWidthMobile: false,
    }
  },
  computed: {
    page: function () {
      const pageData = this.$store.getters.filterPagesByName('soma-tent.markdown');
      if (pageData && typeof pageData != 'undefined') return pageData[0];
      else return {}
    },
    currentImage: function() {
      return this.images[Math.abs(this.currentNumber) % this.images.length];
    },
    swiper() {
      if (this.$refs.mySwiper) return this.$refs.mySwiper.swiper;
    },
    lineup_nav_links_published: function () {
      var lineup_nav_links_published = this.page.lineup_nav.links.filter(function (item) {
        if (item.is_published === true) {
          //console.log('item: ', item);
          return item;
        }
      });
      return lineup_nav_links_published;
    },
  },
  methods : {
    sizing: function(){
      this.windowWidth = window.innerWidth;
      if (this.windowWidth < 768)
        this.isWindowWidthMobile = true; 
      else{
        this.isWindowWidthMobile = false; 
      }
    },
    randomNumber() {
      this.pic1 = Math.floor(Math.random() * (23 - 1) + 23);
      console.log("random num pic1 - ", this.pic1);
    },
    startRotation: function() {
      this.timer = setInterval(this.next, 3000);
    },

    stopRotation: function() {
      clearTimeout(this.timer);
      this.timer = null;
    },

    next: function() {
      this.currentNumber += 1;
    },
    prev: function() {
      this.currentNumber -= 1;
    },
    changeIndex(index) {
      this.sliderValue = index;
    },
  },
  created() {
     var w = window.innerWidth;
    if (w < 768) {
      this.isWindowWidthMobile = true;
    } else {
      this.isWindowWidthMobile = false;
    }
    window.addEventListener('resize', this.sizing);
    window.addEventListener('load', this.sizing);
    this.randomNumber();
    
    /* set lineup menu activeItem to the url it loaded on */
    let lineupLinksPublished = this.lineup_nav_links_published;
    if (this.$route.hash) {
      let activeItem = this.lineup_nav_links_published.filter(function (item) {
        if (item.link == "/lineup/" + window.location.hash) {
          //console.log('window.location.hash: ', window.location.hash);
          return item;
        }
      });
      var filterIndex = this.lineup_nav_links_published.findIndex(function (item) {
        return item.link == activeItem[0].link;
      });
      this.activeItemIndex = filterIndex;
      //console.log('dA + fI aI', this.desktopActive, filterIndex, this.activeItemIndex);
      this.desktopActive = filterIndex + 1;
    } else {
      this.activeItemIndex = 0;
      this.desktopActive = 0;
    }
  },
  beforeMount() {
    //
  },
  mounted() {
    this.startRotation();
    this.$nextTick(() => {
      /* DOSTUFF EMBED INJECT */
      const liveLink = "https://osl-2020.dostff.co/embeds/lineup.js",
        previewToken = "ab186f6a47f16141e12d",
        previewLink = `https://osl-2020.dostff.co/embeds/lineup.js?preview_token=${previewToken}`;

      if (document.getElementById("ds-fest-lineup-js")) {
        //console.log('1.1 element exists');
      } else {
        //console.log('1.2 element does not exist!');
        var element = document.getElementById("dostuff-embed-container");
        let dostuffEmbedProd = document.createElement("script");
        dostuffEmbedProd.setAttribute("id", "dostuff-js");
        dostuffEmbedProd.setAttribute("type", "text/javascript");
        dostuffEmbedProd.setAttribute("ref", "myDiv");
        //dostuffEmbedProd.setAttribute('src', previewLink + previewToken);
        dostuffEmbedProd.setAttribute("src", liveLink);
        element.appendChild(dostuffEmbedProd);
        //console.log('1.4 lineup embed - created() ');
      }
      
    });
    

    function shuffle(array) {
      var tmp,
        current,
        top = array.length;

      if (top)
        while (--top) {
          current = Math.floor(Math.random() * (top + 1));
          tmp = array[current];
          array[current] = array[top];
          array[top] = tmp;
        }

      return array;

      setTimeout(
        () =>
          (this.list = [
            {
              backgroundColor: "#3f51b5",
              width: "100%",
              height: "100%"
            },
            {
              backgroundColor: "#eee",
              width: "100%",
              height: "100%"
            },
            {
              backgroundColor: "#f44336",
              width: "100%",
              height: "100%"
            },
            {
              backgroundColor: "#eee",
              width: "100%",
              height: "100%"
            }
          ]),
        1000
      );
    }

    let picArray = [
      1,
      2,
      3,
      4,
      5,
      6,
    ];

    this.newArray = shuffle(picArray);
    console.log(newArray[0]);
    console.log(newArray[1]);
    console.log(newArray[2]);
    console.log(newArray[3]);
    console.log(newArray[4]);
    console.log(newArray[5]);

  },
  destroyed() {
    window.removeEventListener('resize', this.sizing);
    window.removeEventListener('load', this.sizing);
  }
}
</script>
